import axios from "axios"

// Pfad zu deiner lokalen Datei
const PLZ_SOURCE_URL = "/data/ch-plz.json"

let plzCache = null

export default {
  async init() {
    if (plzCache) return
    try {
      console.log("Lade PLZ Geodaten lokal...")
      const response = await axios.get(PLZ_SOURCE_URL)

      // Deine Datei ist schon ein Objekt: { "8500": { "lat": ..., "lon": ... }, ... }
      // Wir können es direkt nutzen!
      plzCache = response.data

      console.log(`GeoService: Geodaten geladen.`)
    } catch (e) {
      console.error("Konnte PLZ Daten nicht laden", e)
      // Minimaler Fallback falls Datei fehlt
      plzCache = {
        8500: { lat: 47.5536, lon: 8.8926 },
      }
    }
  },

  getCoordinates(plz) {
    if (!plzCache) return null
    // PLZ sicherheitshalber in String wandeln, falls es als Number kommt
    const key = plz.toString()
    return plzCache[key] || null
  },
}
